import { render, staticRenderFns } from "./MajorSystem.vue?vue&type=template&id=04199a56&scoped=true&"
import script from "./MajorSystem.vue?vue&type=script&lang=js&"
export * from "./MajorSystem.vue?vue&type=script&lang=js&"
import style0 from "./MajorSystem.vue?vue&type=style&index=0&id=04199a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04199a56",
  null
  
)

export default component.exports